<template>
  <div class='regist_body'>
    <div class='header'><h1 class='title'>找回密码</h1><router-link class='backToLogin' to='/navigator/auth/login'>返回登录</router-link></div>
    <Step1 @resetPass='resetPass' @error='error'></Step1>
    <SubmitSuccess :title='tips.title' :tipsMsg='tips.tipsMsg' class='prompt-pane' v-if='submitSuccessFlag' @close='submitSuccessFlag=false'></SubmitSuccess>
  </div>
</template>

<script>
import Step1 from './child/Step1';

export default {
  data() {
    return {
      submitSuccessFlag: false,
      tips: {
        title: '提示',
        tipsMsg: '验证码发送成功',
      },
    };
  },
  methods: {
    resetPass() {
      this.$router.push('/navigator');
    },
    // 错误弹窗提示
    error(msg) {
      this.tips.tipsMsg = msg;
      this.submitSuccessFlag = true;
    },
  },
  components: { Step1 },
};
</script>

<style lang='scss' scoped>
.regist_body{
  position: relative;
  max-width: 1200px;
  min-height: 500px;
  margin: 60px auto;
  background: #ffffff;
  .header{
    padding: 0 40px;
    height: 68px;
    line-height: 68px;
    border-bottom: 1px solid #c4c4c4;
    .title{
      float: left;
    }
    .backToLogin{
      float: right;
      color: #666666;
    }
    .backToLogin:hover{
      text-decoration: underline;
    }
  }
  .prompt-pane{
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/auth/ForgetPass.vue